// extracted by mini-css-extract-plugin
export default {"container":"container_src-libs-loading-spinner-_loading-spinner_container_OQh7q"};